// Self-contained data for The Law Offices of Treñas Rubias Dela Cruz Lee-Trimañez & Associates.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/04_Trenas_Rubias_Dela_Cruz_Lee_Trimanez
// (research snapshot 2026-08-21). The firm's own office letterhead and wall plaques (photographed
// at their Iloilo office) confirm the 1918 / 1995 / 2019 name history used below — this traces the
// firm's lineage, not a claim that one unchanged partnership has operated continuously since 1918.
// DivinaLaw affiliation is presented without a start date, per the dossier's caution to reconfirm
// the current relationship before publication.
export const SLUG = "trenas-law-iloilo-concept";

export const BIZ = {
  name: "Treñas Rubias Dela Cruz Lee-Trimañez & Associates",
  shortName: "Treñas Law",
  fullName: "The Law Offices of Treñas Rubias Dela Cruz Lee-Trimañez & Associates",
  address: "2nd Floor, Golden Commercial Center, Iznart Street, Iloilo City 5000",
  phone: "+63333351055",
  phoneDisplay: "(033) 335-1055",
  phoneAlt: "(033) 337-3021",
  email: "trenlaw.office@gmail.com",
  facebook: "https://www.facebook.com/trenaslawoffice",
  mapEmbed: "https://www.google.com/maps?q=Golden+Commercial+Center+Iznart+Street+Iloilo+City&output=embed",
};

export const HISTORY = [
  { year: "1918", title: "Treñas Law Offices", text: "Our Iloilo lineage begins here — marked on our own office wall plaque as the founding year." },
  { year: "1995", title: "Treñas, Treñas & Rubias", text: "We continued under a later partner-name iteration." },
  { year: "2019", title: "Treñas Rubias Dela Cruz Lee-Trimañez & Associates", text: "We took our current name, reflecting our current partnership." },
  { year: "Today", title: "An Iloilo Affiliate of DivinaLaw", text: "We're currently listed as an Iloilo affiliate of DivinaLaw — confirm the current relationship directly." },
];

export const NAV_PAGES = [
  { key: "home", label: "Home", path: "" },
  { key: "history", label: "Our History", path: "/history" },
  { key: "lawyers", label: "Our Lawyers", path: "/lawyers" },
  { key: "practice-areas", label: "Practice Areas", path: "/practice-areas" },
  { key: "contact", label: "Contact", path: "/contact" },
];

export const LAWYERS = [
  { name: "Atty. Aloysius Pacelli C. Dela Cruz II", role: "Managing Partner", note: "Currently identified in public firm material as Managing Partner." },
  { name: "Atty. Jerry P. Treñas", role: "Senior Partner", note: "Currently identified in public firm material as Senior Partner." },
  { name: "Atty. Samantha S. Ledesma", role: "Associate", note: "Joined us after passing the 2025 Bar Examinations; previously worked with us as a paralegal.", photo: "/law/trenas-law-iloilo-concept/atty-ledesma.jpg" },
  { name: "Atty. Sheryl May S. Ledesma-Alabanza", role: "Associate", note: "Publicly associated with us." },
  { name: "Louis Gabriel Espinosa", role: "Lawyer & Registered Medical Technologist", note: "Publicly associated with us, with a professional background that also includes medical technology." },
];

export const OTHER_ASSOCIATED = "Additional professionals publicly associated with us include Maviyah Lee Debarbo and Zarah Joy Paciente.";

export const PRACTICE_AREAS = [
  { title: "Civil Law", text: "General civil law matters and representation." },
  { title: "Commercial & Business Law", text: "Commercial and business-related legal matters." },
  { title: "Criminal Law", text: "Criminal law representation." },
  { title: "Family Law", text: "Family law matters." },
  { title: "Tax Law", text: "Tax-related legal matters." },
  { title: "Property, Purchase & Lease Contracts", text: "Property transactions, purchase agreements and lease contracts." },
  { title: "General Legal Practice", text: "General legal services for individuals and businesses in Iloilo." },
];

// Only one individually-readable recommendation was recovered; the larger review pool is
// aggregate-only and varies by listing/crawl date — presented cautiously as a range.
export const REVIEW = {
  quote: "Recommended Treñas Law Office in Iznart when an r/Iloilo user asked for a lawyer to help with property, purchase and lease-contract matters.",
  source: "Reddit, r/Iloilo",
  date: "October 2025",
  sourceUrl: "https://www.reddit.com/r/Iloilo/comments/1ojv5me",
  aggregateNote: "Public listings put us in roughly the 4–5★ range across about 35 reviews, though the exact figure varies by listing and crawl date.",
};
